import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail, ArrowRight, Loader2 } from "lucide-react";

const PurchaseSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate brief loading to let webhook process
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Layout>
        <section className="section-padding bg-background min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="h-12 w-12 text-primary mx-auto mb-4 animate-spin" />
            <h1 className="text-2xl font-semibold mb-2">Processing your purchase...</h1>
            <p className="text-muted-foreground">Just a moment while we generate your access code(s)</p>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="section-padding bg-background min-h-[60vh]">
        <div className="container-wide max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 rounded-full bg-green-100 mx-auto mb-6 flex items-center justify-center">
            <CheckCircle2 className="h-10 w-10 text-green-600" />
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            Thank you for your purchase. Your access code(s) have been generated and are on their way.
          </p>

          <div className="bg-muted/50 rounded-lg p-6 mb-8">
            <div className="flex items-center justify-center gap-3 mb-3">
              <Mail className="h-6 w-6 text-primary" />
              <span className="text-lg font-medium">Check Your Email</span>
            </div>
            <p className="text-muted-foreground">
              We've sent your access code(s) to the email address you provided. 
              The email includes instructions on how to start your inventory assessment.
            </p>
            <p className="text-sm text-muted-foreground mt-3">
              Don't see it? Check your spam folder or contact hello@partnershiplab.co.uk
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={() => navigate("/start-inventory")} className="gap-2">
              Start Inventory Now
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button variant="outline" onClick={() => navigate("/")}>
              Return Home
            </Button>
          </div>

          {sessionId && (
            <p className="text-xs text-muted-foreground mt-8">
              Reference: {sessionId.slice(0, 20)}...
            </p>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default PurchaseSuccess;
